// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"205":"scraping_batch_view","264":"seller_scraping","562":"scraping","919":"xlsx_viewer"}[chunkId] + "." + {"205":"b2ba9aad","264":"8c7bad66","562":"82fa1561","919":"b2ba9aad"}[chunkId] + ".css";
};